import noop from 'lodash/noop';
import { call, fork, put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import * as Constants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

export function* trackEnded({ payload }) {
  const { duration, currentTime, token, harnessName } = payload;
  const sourceId = yield select(getInDomain('playback.utils.getCurrentPlaylist'));
  const playlistType = yield select(getInDomain('playback.utils.getCurrentPlaylistType'));
  const track = yield select(
    getInDomain('playback.utils.resolveAudioTrackForPlaylist'),
    token,
    sourceId,
  );
  const isAPS = yield select(getInDomain('playback.utils.isPlaylistModelTypeAPSItem'));
  const shouldUseWakeLock = yield select(getInDomain('playback.utils.shouldUseWakeLock'));

  if (shouldUseWakeLock) {
    yield put({
      type: Constants.AudioPlayer.AudioPlayerActions.SET_WAKE_LOCK,
      isOn: true,
    });
  }

  yield put(Actions.Rebuffer.resetCanPlayCount());

  yield call(putAndWait, {
    type: Constants.Playback.ActionTypes.TRACK_COMPLETE_AUDIO_ANALYTICS,
    payload: {
      track,
      duration,
      currentTime,
      harnessName,
    },
  });

  // We need to pass the track token into onTrackEnd because the AudioPlayer reducer has already run for
  // this action and reset the state
  yield put(
    getInDomain(
      'analytics.actions.logTrackEnd',
      noop,
    )({
      currentTime,
      duration,
      playlistType,
      reason: 'completed',
      token,
      track,
    }),
  );

  // @note it is key to understand the decision not to return here: we don't
  // want to block the current action from reaching the reducer, but this
  // entire notion depends on the fact that no other handler will make
  // assumptions about how to handle this action -- for better concurrency we
  // would need to move to a much more strict convention
  if (yield select(getInDomain('playback.utils.isNowPlayingReplayedTrack'))) {
    yield put(
      Actions.SmartConversion.triggerUpsell(
        Constants.SmartConversion.UPSELL_EVENTS.COMPLETE_REPLAY,
      ),
    );
  }
  const isAudioAd = yield select(getInDomain('ads.utils.isAudioAd', false), track);
  if (isAudioAd) {
    yield call(getInDomain('audioAds.utils.audioAdEnded', null), track);
  }

  if (isAPS) {
    yield call(
      putAndWait,
      getInDomain('playback.actions.itemEnded')({
        sourceId,
        itemPandoraId: token,
        elapsedTime: currentTime,
      }),
    );
  } else {
    yield fork(putAndWait, {
      type: Constants.Playback.ActionTypes.PLAYBACK_TRACK_ENDED,
      payload,
    });
  }
}
